// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"480b1dcf","453":"a5ac7fb3","455":"201fdb24","976":"58f7b060","977":"d819186e"}[chunkId] + ".chunk.js";
};